import { NumberValue } from '../../../utils'
import { PRICE_DECIMAL_PLACES } from '../constants/priceDecimalPlaces'

export const getAmountExcludingVat = (amountIncludingVat: number, vatRatePercent?: number) => {
  if (!vatRatePercent) {
    return amountIncludingVat
  }

  return new NumberValue(amountIncludingVat).divide(1 + vatRatePercent).getRounded(PRICE_DECIMAL_PLACES)
}
